import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // ES6

interface ICustomQuillProps {
    value: ReactQuill.Value | undefined
    onChange: (content: any, delta: any, source: any, editor: any) => void
    // onBlur: (previousRange: any, source: any, editor: any) => void
    style?: React.CSSProperties
}

let CustomQuillEditor = (props: ICustomQuillProps) => {

    var Link = Quill.import('formats/link');
    var sanitizeFunc = Link.sanitize;
    Link.sanitize = function customSanitizeLinkInput(linkValueInput: any) {
        var val = linkValueInput;

        if (!/^https?:/.test(val))
            val = "https://" + val;

        return sanitizeFunc.call(this, val);
    };

    const formats = [
        'bold',
        'color',
        'font',
        'italic',
        'link',
        'size',
        'strike',
        'underline',
        'blockquote',
        'header',
        'indent',
        'list',
        'align',
        'direction',
    ];

    return (
        <ReactQuill
            value={props.value}
            bounds={`[data-text-editor="name"]`}
            onChange={props.onChange}
            // onBlur={props.onBlur}
            formats={formats}
            style={props.style}
        />
    );
}

export default CustomQuillEditor;

